import { ebookApi } from '@services/api';

export interface AlertResponse {
  data: string;
  id: number;
  level: number;
  name: string;
  unclosable: boolean;
}

const alertApi = ebookApi.injectEndpoints({
  endpoints: (builder) => ({
    getAlerts: builder.query<AlertResponse[], number>({
      query: (id) => ({
        url: `alerts`,
        method: 'GET',
        params: { id },
      }),
    }),
    deleteAlert: builder.mutation<AlertResponse, { id: number }>({
      query: (args) => ({
        url: `alerts/${args.id}`,
        method: 'DELETE',
        params: args,
      }),
    }),
  }),
});

export const { useGetAlertsQuery, useDeleteAlertMutation } = alertApi;
